import { Dayjs } from 'dayjs';
import { Mode, WeekDayIndex } from 'types/availability';
import findNearestWeekStart from 'utils/date/findNearestWeekStart';

export default function useTimeline(
  start: Dayjs,
  end: Dayjs,
  mode: Mode,
  weekFirstDay: WeekDayIndex = 5
) {
  let from = start;
  let to = end;

  if (mode === 'week') {
    // find nearest possible week start
    from = findNearestWeekStart(from, weekFirstDay);
    to = findNearestWeekStart(to, weekFirstDay);
  }

  const days = [];
  const weeks = [];
  const months = new Map<string, number>();

  const diff = to.diff(from, 'day');
  for (let i = 0; i <= diff; i++) {
    const format = from.format('YYYY-MM-DD');
    const isStartOfWeek = from.weekday() === weekFirstDay;

    days.push(format);
    if (isStartOfWeek) {
      weeks.push(format);
    }

    const monthFormat = from.format('YYYY-MM');
    // count number of visible days/weeks in month
    if (mode === 'day' || (mode === 'week' && isStartOfWeek)) {
      months.set(monthFormat, (months.get(monthFormat) || 0) + 1);
    }

    from = from.add(1, 'day');
  }

  return {
    days,
    weeks,
    months: Array.from(months),
  };
}
